import React from "react";
import { Outlet } from "react-router-dom";

const StudyMaterial = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default StudyMaterial;
